/**
 * fetch com o JWT da sessão — para as rotas do webhook que passam a exigir login
 * da equipe (visit-summary, briefing/regenerate, labs/classified, recording/*).
 *
 * Por que existe: essas rotas foram registradas antes do middleware de login do
 * webhook e respondiam a qualquer um que soubesse um id — o visit-summary
 * devolvia a carta da visita. Primeiro o portal passa a mandar o login (esta
 * função); depois o webhook fecha as rotas. Sem sessão, a chamada segue sem o
 * header e o webhook responde 401.
 */
import { supabase } from './supabaseClient';

export async function webhookFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  let token: string | undefined;
  try {
    token = (await supabase.auth.getSession()).data.session?.access_token;
  } catch {
    token = undefined;
  }
  const headers = new Headers(init.headers || {});
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(input, { ...init, headers });
}
